/**
 * Created by iosc on 2018/1/15.
 */

import React, {PureComponent} from 'react'
import './About.css'
import {Switch, Route} from 'react-router-dom'
import News1 from './News1'
import News2 from './News2'
import News3 from './News3'
import News4 from './News4'
import News5 from './News5'

class About extends PureComponent {
	render() {
		return (
			<div>
				<img className="header" alt="introduction1" src={require('./images/news1.jpg')}/>
				<div className="header-s" alt="introduction1"
						 style={{backgroundImage: `url('${require('./images/news1.jpg')}')`}}/>
				<Switch>
					<Route path='/news/1' component={News1}/>
					<Route path='/news/2' component={News2}/>
					<Route path='/news/3' component={News3}/>
					<Route path='/news/4' component={News4}/>
					<Route path='/news/5' component={News5}/>
					<Route path='/news' react render={() => {
						return (
							<div>
								<div style={{
									fontSize: '48px',
									color: '#4e4e4e',
									marginTop: '54px',
									marginBottom: '47px',
									display: 'flex', flexDirection: 'column', alignItems: 'center'
								}}>最新动态
									<div style={{
										width: '26px',
										height: '2px',
										backgroundColor: '#ff6956'
									}}></div>
								</div>
								<div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
									<div style={{display: 'flex'}}>
										<div style={{display: 'flex', marginRight: '40px'}} onClick={() => {
											this.props.history.push(this.props.location.pathname + '/4')
										}}>
											<div style={{
												width: '300px',
												height: '168px',
												marginRight: '20px',
												backgroundImage: `url('https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F4.1.webp')`,
												backgroundSize: 'cover'
											}}></div>
											<div style={{width: '260px'}}>
												<div style={{fontSize: '20px', color: '#4e4e4e'}}>老板，开连锁店吗？开之前，你需要知道这些……</div>
												<div style={{
													fontSize: '14px',
													color: '#989898'
												}}>连锁简直无处不在。连锁门店的盈利规模也不用多提。更好玩的事实是，当你的连锁慢慢做起来，盈利会变得越来越简单，账面的数字也会越来越好看。
												</div>
											</div>
										</div>
										<div style={{display: 'flex', marginBottom: '47px'}} onClick={() => {
											this.props.history.push(this.props.location.pathname + '/3')
										}}>
											<div style={{
												width: '300px',
												height: '168px',
												marginRight: '20px',
												backgroundImage: `url(https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.1.webp)`,
												backgroundSize: 'cover'
											}}></div>
											<div style={{width: '260px'}}>
												<div style={{fontSize: '20px', color: '#4e4e4e'}}>世界性“中餐厨师荒”荒了7年，业界提出了新的解决办法！</div>
												<div style={{
													fontSize: '14px',
													color: '#989898'
												}}>“厨师荒”荒了多少年？我们来理理时间线。
												</div>
											</div>
										</div>
									</div>
									<div style={{display: 'flex'}}>
										<div style={{display: 'flex', marginRight: '40px'}} onClick={() => {
											this.props.history.push(this.props.location.pathname + '/2')
										}}>
											<div style={{
												width: '300px',
												height: '168px',
												marginRight: '20px',
												backgroundImage: `url('https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F2.1.webp')`,
												backgroundSize: 'cover'
											}}></div>
											<div style={{width: '260px'}}>
												<div style={{fontSize: '20px', color: '#4e4e4e'}}>新门店时代！如何装点门店吸引更多顾客进门消费？</div>
												<div style={{
													fontSize: '14px',
													color: '#989898'
												}}>门店最宝贵的资产，不是店面的大小，豪华的装修，而是门店门前熙熙攘攘的路人——门前路过的行人越多，进店的可能性越大，这也是为什么门店愿意开在人群最密集的地方之一。而进店的路人越多，转化为购买行为的概率也越大。
												</div>
											</div>
										</div>
										<div style={{display: 'flex', marginBottom: '227px'}} onClick={() => {
											this.props.history.push(this.props.location.pathname + '/1')
										}}>
											<div style={{
												width: '300px',
												height: '168px',
												marginRight: '20px',
												backgroundImage: `url(https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F11.jpeg)`,
												backgroundSize: 'cover'
											}}></div>
											<div style={{width: '260px'}}>
												<div style={{fontSize: '20px', color: '#4e4e4e'}}>海外空中烹饪课堂横空出世！美未科技助力海外中餐传播</div>
												<div style={{
													fontSize: '14px',
													color: '#989898'
												}}>谈及外国对中国的印象，除了功夫以外，最深入人心的可能就是中华美食了。一部《舌尖上的中国》不仅点燃了中国的社交媒体，也在国际上产生了很大的影响。
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						)
					}}/>
				</Switch>

			</div>
		)
	}
}

export default About


// WEBPACK FOOTER //
// ./src/News.js